import { Icon } from '../common';

// The command strip's headcount segment (daily-command-strip AC13).
//
// NO MONEY FIGURE HERE. The outstanding balance was tried on the rail and cut:
// it was a second, quieter question competing with the headcount, and it
// already has a home in the panel's own foot where it is totalled against the
// stays that owe it.
//
// The count takes --brand-deep. --brand owns prime stats in this app and this is
// the one figure on the rail; in plain ink it read as body copy that happened to
// be large.

export interface ResidenceSegmentProps {
  count: number;
  open: boolean;
  onToggle: () => void;
}

export function ResidenceSegment({ count, open, onToggle }: ResidenceSegmentProps) {
  return (
    <div className="cs-seg cs-seg-res">
      <button type="button" className="cs-seg-btn" onClick={onToggle} aria-expanded={open}>
        <span className="cs-seg-ico" aria-hidden="true">
          <Icon name="paw" size={14} />
        </span>
        <span className="cs-seg-title">In residence</span>
        {count === 0 ? (
          <span className="cs-none">Block empty</span>
        ) : (
          <span className="cs-count mono">{count}</span>
        )}
        <span className="cs-chev" aria-hidden="true">
          <Icon name="chevron-down" size={13} />
        </span>
      </button>
    </div>
  );
}
